import React from 'react'
import { observable } from 'mobx'
import { Row, Col } from 'react-bootstrap'
import { getFilterParams, constructQueryParam } from 'src/deps'
import { IS_BROWSER } from 'src/utils'
import { i18nTranslate } from 'src/utils'

class OrderHistoryFooter extends React.Component {
  @observable activePage = 1

  fetchOrderList = async () => {
    if (IS_BROWSER) {
      const queryParams = getFilterParams(location) || {}
      const params = {
        page: queryParams.page || 1,
        size: 5,
      }
      this.activePage = parseInt(params.page)
    }
  }

  handlePagination = async pageNumber => {
    this.activePage = pageNumber
    const queryParams = getFilterParams(location)
    queryParams.page = pageNumber
    constructQueryParam(this.props, queryParams)
    this.fetchOrderList(this.props)
  }

  render() {
    // const orderInfo = orderHistoryContainer.getAllOrders()
    // const pageableInfo = get(orderInfo, 'pageableInfo', {})
    // const { totalCount, size } = pageableInfo
    return (
      <Row noGutters className="m-0 mt-2">
        <Col lg={12} className="px-3">
          <span className="m-0">
            {i18nTranslate(
              'orderHistory.footerTitle',
              "Why can't I return / cancel my order"
            )}
            ?
          </span>
          <p className="m-0">
            {i18nTranslate(
              'orderHistory.footerDescription',
              'Once your order has been delivered, you can start the return process. Partially shipped or pending orders cannot be cancelled.'
            )}
          </p>
        </Col>
        <Col>
          {/*totalCount > size && (
            <Pagination
              handlePagination={this.handlePagination}
              totalPages={Math.ceil(totalCount / size)}
              active={this.activePage}
            />
          )*/}
        </Col>
      </Row>
    )
  }
}

export default OrderHistoryFooter
export { OrderHistoryFooter }
